<script lang="ts">
    import { getProtocol } from "../../../api"
    import Table from "../../widgets/Table.svelte"
    import ProtocolAction from "./protocol/ProtocolAction.svelte"
    import { createEventDispatcher } from "svelte"
    import ProtocolDetails from "./protocol/ProtocolDetails.svelte"
    import { mdiEmail, mdiFileDocument, mdiPencil, mdiPlus } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import { _ } from "svelte-i18n"
    export let operation: Operation

    const gridBreakPoint = 1300
    let outerWidth: number
    let outerHeight: number
    let innerHeight: number
    let scrollY: number
    let dispatch = createEventDispatcher()

    let protocolItems: Protocol[] = []

    function getProtocolItems() {
        getProtocol(operation.id, "operation-out")
            .then((res) => {
                protocolItems = res.map((item) => {
                    const date = new Date(item.dateTime)
                    let germanFormattedDate = date.toLocaleDateString("de-DE", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })
                    let time = date.toLocaleTimeString("de-DE", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })

                    //@ts-ignore
                    item.dateTime = `${germanFormattedDate} ${time}`
                    item.editorName = `${item.editor.firstname} ${item.editor.lastname}`
                    //@ts-ignore
                    item.details = "Details"
                    return item
                })
            })
            .catch((e) => {
                console.log(e)
            })
    }
    getProtocolItems()
</script>

<svelte:window bind:outerWidth bind:outerHeight bind:innerHeight bind:scrollY />
<div class="operation-protocol" style="padding-top: 1rem">
    <h3 style="padding: 10px;">
        {$_("components.operationProtocol.protocolForOffer", { values: { number: operation.number } })}
    </h3>
    {#if protocolItems.length === 0}
        <div style="padding: 15px;">{$_("components.operationProtocol.noProtocol")}</div>
    {:else}
        <Table
            className="protocol-items"
            rows="{protocolItems.reverse()}"
            gridview="{outerWidth <= gridBreakPoint}"
            columns="{[
                {
                    label: $_('components.operationProtocol.timestamp'),
                    field: 'dateTime',
                    sortable: false,
                    className: 'mw-120 w-120',
                },
                {
                    label: $_('components.operationProtocol.action'),
                    field: 'action',
                    sortable: false,
                    className: '',
                    component: ProtocolAction,
                    getProps(item) {
                        return {
                            item,
                        }
                    },
                },
                {
                    label: $_('components.operationProtocol.editor'),
                    field: 'editorName',
                    sortable: false,
                    className: 'mw-250 w-250',
                },
                {
                    label: $_('components.operationProtocol.details'),
                    field: 'details',
                    component: ProtocolDetails,
                    getProps(item) {
                        return {
                            item,
                        }
                    },
                    sortable: false,
                    className: 'mw-250 w-250',
                },
            ]}"
            on:click="{(e) => {}}"
        />
    {/if}

    <div class="legends" style="padding: 0px 10px;">
        <div class="legend">
            <div class="headline">{$_("components.operationProtocol.legend")}</div>
            <div class="items">
                <section>
                    <div class="item">
                        <div class="icon"><Icon path="{mdiEmail}" size="24px" /></div>
                        <div class="text">{$_("components.operationProtocol.emailSent")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <Icon path="{mdiPlus}" size="24px" />
                        </div>
                        <div class="text">{$_("components.operationProtocol.added")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <Icon path="{mdiFileDocument}" size="24px" />
                        </div>
                        <div class="text">{$_("components.operationProtocol.created")}</div>
                    </div>
                    <div class="item">
                        <div class="icon"><Icon path="{mdiPencil}" size="24px" /></div>
                        <div class="text">{$_("components.operationProtocol.edited")}</div>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <div style="flex: 1"></div>
    <div class="overlay_buttons">
        <div class="layout layout-gap-sm align-items-left">
            <button
                class="btn btn-secondary btn-blue"
                on:click="{() => {
                    dispatch('closeTab')
                }}"
            >
                {$_("components.operationProtocol.close")}
            </button>
        </div>
    </div>
</div>
